import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';

import { AppSessionService } from './session/app-session.service';
import { AppUrlService } from './nav/app-url.service';
import { AppAuthService } from './auth/app-auth.service';
import { AppRouteGuard } from './auth/auth-route-guard';
import { LocalizePipe } from '@shared/pipes/localize.pipe';

import { AbpPaginationControlsComponent } from './components/pagination/abp-pagination-controls.component';
import { AbpValidationSummaryComponent } from './components/validation/abp-validation.summary.component';
import { AbpModalHeaderComponent } from './components/modal/abp-modal-header.component';
import { AbpModalFooterComponent } from './components/modal/abp-modal-footer.component';
import { LayoutStoreService } from './layout/layout-store.service';

import { BusyDirective } from './directives/busy.directive';
import { EqualValidator } from './directives/equal-validator.directive';
import { UserSelectModalComponent } from './SelectModals/user-select-modal/user-select-modal.component';
import { CustomerSelectModalComponentextends } from './SelectModals/customer-select-modal/customer-select-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTreeModule } from '@angular/material/tree';
import { OrganizationTreeCheckBoxComponent } from './SelectModals/organization-tree-check-box/organization-tree-check-box.component';
import { OrganizationTreeRadioButtonComponent } from './SelectModals/organization-tree-radio-button/organization-tree-radio-button.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { MatRadioModule } from '@angular/material/radio';
import { MatCardModule } from '@angular/material/card';
import { InputDialogComponent } from './components/input-dialog/input-dialog.component';
import { TimelineBoxComponent } from './components/timeline-box/timeline-box.component';
import { TagInputComponent } from './components/tag-input/tag-input.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { MatDatepickerModule } from "@angular/material/datepicker";
import { DateAdapter, MAT_DATE_FORMATS, MatNativeDateModule } from "@angular/material/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { NgxPersianModule } from 'ngx-persian';
import { JalaliDateAdapter } from "./helpers/jalali-date-adapter"

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'YYYY/MM/DD'
  },
  display: {
    dateInput: 'YYYY/MM/DD',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};


@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        NgxPaginationModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatButtonModule,
        MatIconModule,
        FormsModule,
        MatSelectModule,
        MatTreeModule,
        MatRadioModule,
        MatCardModule,
        MatChipsModule,
        MatDialogModule,
        MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMomentDateModule,
    NgxPersianModule,
        TabsModule.forRoot(),

    ],
    declarations: [
        AbpPaginationControlsComponent,
        AbpValidationSummaryComponent,
        AbpModalHeaderComponent,
        AbpModalFooterComponent,
        LocalizePipe,
        BusyDirective,
        EqualValidator,
        UserSelectModalComponent,
        OrganizationTreeCheckBoxComponent,
        OrganizationTreeRadioButtonComponent,
        CustomerSelectModalComponentextends,
        InputDialogComponent,
        TimelineBoxComponent,
        TagInputComponent,
        DatePickerComponent,
    ],
    exports: [
        AbpPaginationControlsComponent,
        AbpValidationSummaryComponent,
        AbpModalHeaderComponent,
        AbpModalFooterComponent,
        LocalizePipe,
        BusyDirective,
        EqualValidator,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatButtonModule,
        MatIconModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatTreeModule,
        OrganizationTreeCheckBoxComponent,
        OrganizationTreeRadioButtonComponent,
        MatRadioModule,
        MatCardModule,
        TabsModule,
        TimelineBoxComponent,
        TagInputComponent,
        DatePickerComponent
    ]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [
                AppSessionService,
                AppUrlService,
                AppAuthService,
                AppRouteGuard,
                LayoutStoreService,
                  { provide: DateAdapter, useClass: JalaliDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
            ]
        };
    }
}
